/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Fairuse_Section3list_Nature2Inputs */

const id_misc_fairuse_section3list_nature2 = /** @type {(inputs: Misc_Fairuse_Section3list_Nature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sifat Karya yang Dilindungi Hak Cipta:`)
};

const ms_misc_fairuse_section3list_nature2 = /** @type {(inputs: Misc_Fairuse_Section3list_Nature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sifat Karya Berhak Cipta:`)
};

const da_misc_fairuse_section3list_nature2 = /** @type {(inputs: Misc_Fairuse_Section3list_Nature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naturen af det Ophavsretlige Værk:`)
};

const de_misc_fairuse_section3list_nature2 = /** @type {(inputs: Misc_Fairuse_Section3list_Nature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Art des urheberrechtlich geschützten Werks:`)
};

const en_us2_misc_fairuse_section3list_nature2 = /** @type {(inputs: Misc_Fairuse_Section3list_Nature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nature of the Copyrighted Work:`)
};

const es_es2_misc_fairuse_section3list_nature2 = /** @type {(inputs: Misc_Fairuse_Section3list_Nature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naturaleza de la obra protegida:`)
};

const es_mx2_misc_fairuse_section3list_nature2 = /** @type {(inputs: Misc_Fairuse_Section3list_Nature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naturaleza del trabajo protegido:`)
};

const fil_misc_fairuse_section3list_nature2 = /** @type {(inputs: Misc_Fairuse_Section3list_Nature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalikasan ng Akdang May Copyright:`)
};

const fr_misc_fairuse_section3list_nature2 = /** @type {(inputs: Misc_Fairuse_Section3list_Nature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nature de l'œuvre protégée :`)
};

const it_misc_fairuse_section3list_nature2 = /** @type {(inputs: Misc_Fairuse_Section3list_Nature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Natura dell'opera protetta da copyright:`)
};

const hu_misc_fairuse_section3list_nature2 = /** @type {(inputs: Misc_Fairuse_Section3list_Nature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A szerzői joggal védett mű természete:`)
};

const nl_misc_fairuse_section3list_nature2 = /** @type {(inputs: Misc_Fairuse_Section3list_Nature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aard van het auteursrechtelijk beschermde werk:`)
};

const no_misc_fairuse_section3list_nature2 = /** @type {(inputs: Misc_Fairuse_Section3list_Nature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Art av det opphavsrettsbeskyttede verket:`)
};

const pl_misc_fairuse_section3list_nature2 = /** @type {(inputs: Misc_Fairuse_Section3list_Nature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charakter dzieła chronionego:`)
};

const pt_br2_misc_fairuse_section3list_nature2 = /** @type {(inputs: Misc_Fairuse_Section3list_Nature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Natureza da Obra Protegida por Direitos Autorais:`)
};

const pt_misc_fairuse_section3list_nature2 = /** @type {(inputs: Misc_Fairuse_Section3list_Nature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Natureza da obra protegida:`)
};

const ro_misc_fairuse_section3list_nature2 = /** @type {(inputs: Misc_Fairuse_Section3list_Nature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Natura operei protejate:`)
};

const fi_misc_fairuse_section3list_nature2 = /** @type {(inputs: Misc_Fairuse_Section3list_Nature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekijänoikeudella suojatun teoksen luonne:`)
};

const sv_misc_fairuse_section3list_nature2 = /** @type {(inputs: Misc_Fairuse_Section3list_Nature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ av upphovsrättsskyddat verk:`)
};

const vi_misc_fairuse_section3list_nature2 = /** @type {(inputs: Misc_Fairuse_Section3list_Nature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bản chất của tác phẩm có bản quyền:`)
};

const tr_misc_fairuse_section3list_nature2 = /** @type {(inputs: Misc_Fairuse_Section3list_Nature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telif Hakkıyla Korunan Çalışmanın Niteliği:`)
};

const cs_misc_fairuse_section3list_nature2 = /** @type {(inputs: Misc_Fairuse_Section3list_Nature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Povaha chráněného díla:`)
};

const bg_misc_fairuse_section3list_nature2 = /** @type {(inputs: Misc_Fairuse_Section3list_Nature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Естество на защитеното произведение:`)
};

const ru_misc_fairuse_section3list_nature2 = /** @type {(inputs: Misc_Fairuse_Section3list_Nature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Характер охраняемого авторским правом произведения:`)
};

const uk_misc_fairuse_section3list_nature2 = /** @type {(inputs: Misc_Fairuse_Section3list_Nature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Характер захищеної роботи:`)
};

const ar_misc_fairuse_section3list_nature2 = /** @type {(inputs: Misc_Fairuse_Section3list_Nature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`طبيعة العمل المحمي بحقوق الطبع والنشر:`)
};

const hi_misc_fairuse_section3list_nature2 = /** @type {(inputs: Misc_Fairuse_Section3list_Nature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रकृति:`)
};

const th_misc_fairuse_section3list_nature2 = /** @type {(inputs: Misc_Fairuse_Section3list_Nature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลักษณะของงานที่มีลิขสิทธิ์:`)
};

const ja_misc_fairuse_section3list_nature2 = /** @type {(inputs: Misc_Fairuse_Section3list_Nature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`著作権で保護された作品の性質：`)
};

const zh_cn2_misc_fairuse_section3list_nature2 = /** @type {(inputs: Misc_Fairuse_Section3list_Nature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`受版权作品的性质：`)
};

const zh_hant1_misc_fairuse_section3list_nature2 = /** @type {(inputs: Misc_Fairuse_Section3list_Nature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`受版權作品的性質：`)
};

const ko_misc_fairuse_section3list_nature2 = /** @type {(inputs: Misc_Fairuse_Section3list_Nature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`저작권 보호 저작물의 성격:`)
};

/**
* | output |
* | --- |
* | "Nature of the Copyrighted Work:" |
*
* @param {Misc_Fairuse_Section3list_Nature2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_fairuse_section3list_nature2 = /** @type {((inputs?: Misc_Fairuse_Section3list_Nature2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Fairuse_Section3list_Nature2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_fairuse_section3list_nature2(inputs)
	if (locale === "ms") return ms_misc_fairuse_section3list_nature2(inputs)
	if (locale === "da") return da_misc_fairuse_section3list_nature2(inputs)
	if (locale === "de") return de_misc_fairuse_section3list_nature2(inputs)
	if (locale === "en-US") return en_us2_misc_fairuse_section3list_nature2(inputs)
	if (locale === "es-ES") return es_es2_misc_fairuse_section3list_nature2(inputs)
	if (locale === "es-MX") return es_mx2_misc_fairuse_section3list_nature2(inputs)
	if (locale === "fil") return fil_misc_fairuse_section3list_nature2(inputs)
	if (locale === "fr") return fr_misc_fairuse_section3list_nature2(inputs)
	if (locale === "it") return it_misc_fairuse_section3list_nature2(inputs)
	if (locale === "hu") return hu_misc_fairuse_section3list_nature2(inputs)
	if (locale === "nl") return nl_misc_fairuse_section3list_nature2(inputs)
	if (locale === "no") return no_misc_fairuse_section3list_nature2(inputs)
	if (locale === "pl") return pl_misc_fairuse_section3list_nature2(inputs)
	if (locale === "pt-BR") return pt_br2_misc_fairuse_section3list_nature2(inputs)
	if (locale === "pt") return pt_misc_fairuse_section3list_nature2(inputs)
	if (locale === "ro") return ro_misc_fairuse_section3list_nature2(inputs)
	if (locale === "fi") return fi_misc_fairuse_section3list_nature2(inputs)
	if (locale === "sv") return sv_misc_fairuse_section3list_nature2(inputs)
	if (locale === "vi") return vi_misc_fairuse_section3list_nature2(inputs)
	if (locale === "tr") return tr_misc_fairuse_section3list_nature2(inputs)
	if (locale === "cs") return cs_misc_fairuse_section3list_nature2(inputs)
	if (locale === "bg") return bg_misc_fairuse_section3list_nature2(inputs)
	if (locale === "ru") return ru_misc_fairuse_section3list_nature2(inputs)
	if (locale === "uk") return uk_misc_fairuse_section3list_nature2(inputs)
	if (locale === "ar") return ar_misc_fairuse_section3list_nature2(inputs)
	if (locale === "hi") return hi_misc_fairuse_section3list_nature2(inputs)
	if (locale === "th") return th_misc_fairuse_section3list_nature2(inputs)
	if (locale === "ja") return ja_misc_fairuse_section3list_nature2(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_fairuse_section3list_nature2(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_fairuse_section3list_nature2(inputs)
	return ko_misc_fairuse_section3list_nature2(inputs)
});
export { misc_fairuse_section3list_nature2 as "misc.fairUse.section3List.nature" }